import { axios } from '@/services/axios';

export const createSBC = (sbcData) => {
    return axios.post('/sessionbordercontroller/', sbcData);
};
